<template>
  <div class="col-xs-12">
    <b-btn :pressed="selected === 'all'" @click="click('all')" :class="['btn btn-info', selected === 'all' ? 'bg-info' : '']">{{'all' | translate}}</b-btn>
    <b-btn v-for="channel in $store.getters.filterChannels" :key="channel.id" :class="['btn btn-outline mr-5', selected === channel.id ? 'bg-white': '']" @click="click(channel)"><i :class="['fa', channel.icon, 'mr-5']"></i>{{channel.name}}</b-btn>
  </div>
</template>

<script>
  export default {
    name: "ChannelsFilter",
    data() {
      return {
        selected: 'all'
      }
    },
    methods: {
      click (event) {
        this.selected = event === 'all' ? 'all' : event.id
        this.$emit('selectedChannel', this.selected)
      }
    },
    mounted () {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/ChannelsfFilter.vue